import { render } from "./ChannelStatsComponent.vue?vue&type=template&id=1b6bf492&scoped=true"
import script from "./ChannelStatsComponent.vue?vue&type=script&lang=js"
export * from "./ChannelStatsComponent.vue?vue&type=script&lang=js"

import "./ChannelStatsComponent.vue?vue&type=style&index=0&id=1b6bf492&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6bf492"]])

export default __exports__